import React, { useEffect, useMemo, useState } from "react";
import Header from "../../components/Header/Header";
import { useDispatch, useSelector } from "react-redux";
import { getHomepageAction } from "../../reduxThings/slices/DigipankSlices";
import Label from "../../components/Label/Label";
import CustomButton from "../../components/CustomButton/CustomButton";
import { Route, Routes, useNavigate } from "react-router-dom";
import "./homepage.scss";
import Slider from "react-slick";
import AiImg from "../../assests/img/ai.svg";
import Google from "../../assests/img/google.svg";
import AngularImg from "../../assests/img/angular.svg";
import PythonImg from "../../assests/img/python.svg";
import NodeImg from "../../assests/img/node.svg";
import ReactImg from "../../assests/img/react.svg";
import XDImg from "../../assests/img/xd.svg";
import FigmaImg from "../../assests/img/figma.svg";
import OpenAiImg from "../../assests/img/openai.svg";
import GeminiImg from "../../assests/img/gemini-color.svg";
import CopilotImg from "../../assests/img/copilot-color.svg";
import TensorFlowImg from "../../assests/img/icons8-tensorflow-96.svg";
import PyTorchImg from "../../assests/img/pytorch-icon.svg";
import AwsImg from "../../assests/img/aws-color.svg";
import LangChainImg from "../../assests/img/langchain-color.svg";
import lamaImg from "../../assests/img/llamaindex-color.svg";
import NvidiaImg from "../../assests/img/nvidia-color.svg";
import StableDiffusionImg from "../../assests/img/stability-color.svg";
import MidJourneyImg from "../../assests/img/midjourney.svg";
import ClaudeImg from "../../assests/img/claude-color.svg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import IotImg from "../../assests/img/iot.svg";
import WebImg from "../../assests/img/web.svg";
import SeoImg from "../../assests/img/seo.svg";
import MobileImg from "../../assests/img/mobile.svg";
import UXImg from "../../assests/img/ui.svg";
import SMMImg from "../../assests/img/smm.svg";
import socialImg from "../../assests/img/social.svg";
import scooterImg from "../../assests/img/scooter.svg";
import healthImg from "../../assests/img/health.svg";
import storeImg from "../../assests/img/store.svg";
import tradeImg from "../../assests/img/trade.svg";
import shoppingImg from "../../assests/img/shopping.svg";
import ContactUs from "../../components/ContactUs/ContactUs";
import Footer from "../../components/Footer/Footer";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import workshopImg from "../../assests/img/workshop.svg";
import productImg from "../../assests/img/product.svg";
import blogImg from "../../assests/img/blog.svg";
import AutomationImg from "../../assests/img/robotic-arms-modern-factory-setting.jpg";
import quoteTopImg from "../../assests/img/quote-top.svg";
import quoteBottomImg from "../../assests/img/quote-bottom.svg";
import { useTranslation } from "react-i18next";
import { current } from "@reduxjs/toolkit";
import CaseStudy from "../CaseStudy/CaseStudy";
import BlogData from "../../Data/Blog(Content11).json";
import * as LottiePlayer from "@lottiefiles/lottie-player";
import { scrollPageToTop } from "../../util/scroll";
import { fetchBlogList } from "../../services/blogApi";
import { fetchCaseStudyList } from "../../services/caseStudyApi";
import HomepageJsonUpload from "../../components/HomepageJsonUpload/HomepageJsonUpload";

import {
  buildBlogPath,
  buildCaseStudyPath,
  pickRandomItems,
} from "../../util/slugId";
import { getBlogImage, getCaseStudyImage } from "../../util/mediaHelpers";
import Seo from "../../components/Seo/Seo";
import { PAGE_SEO } from "../../config/seoConfig";

const Homepage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [key, setKey] = useState("1");
  const [activeCaseStudyTab, setActiveCaseStudyTab] = useState(null);
  const [carousalStatus] = useState(true);

  useEffect(() => {
    dispatch(getHomepageAction());
  }, [dispatch]);

  const appData = useSelector(
    (e) => e.DigipankSlice.homepageState.HomepageData,
  );

  useEffect(() => {
    if (typeof appData?.title === "string") {
      scrollPageToTop();
    }
  }, [appData?.title]);

  useEffect(() => {
    if (!carousalStatus || !appData?.processmanagement?.processData?.length) {
      return;
    }

    const processIds = appData.processmanagement.processData.map(
      (item) => item.id,
    );
    setKey(processIds[0]);

    const interval = setInterval(() => {
      setKey((current) => {
        const currentIndex = processIds.findIndex(
          (id) => String(id) === String(current),
        );
        const nextIndex =
          currentIndex === -1 || currentIndex === processIds.length - 1
            ? 0
            : currentIndex + 1;

        return processIds[nextIndex];
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [carousalStatus, appData?.processmanagement?.processData]);

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (!appData?.why?.data?.length) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) =>
        prev === appData.why.data[0].points.length - 1 ? 0 : prev + 1,
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [appData]);

  const clickToNavigate = (page) => {
    if (page === "contactUs") {
      navigate("/contactpage");
    }
  };
  const [randomItems, setRandomItems] = useState([]);
  const [caseStudyItems, setCaseStudyItems] = useState([]);

  useEffect(() => {
    const loadBlogItems = async () => {
      try {
        const items = await fetchBlogList();
        setRandomItems(pickRandomItems(items, 3));
      } catch (error) {
        setRandomItems(pickRandomItems(BlogData, 3));
      }
    };

    loadBlogItems();
  }, []);

  useEffect(() => {
    const loadCaseStudies = async () => {
      try {
        const items = await fetchCaseStudyList();
        setCaseStudyItems(items);
      } catch (error) {
        setCaseStudyItems([]);
      }
    };

    loadCaseStudies();
  }, []);

  const navigateToBlogPage = (item) => {
    navigate(buildBlogPath(item.id));
  };
  const arrayImg = [
    {
      id: 1,
      im: AiImg,
    },
    {
      id: 2,
      im: Google,
    },
    {
      id: 3,
      im: AngularImg,
    },
    {
      id: 4,
      im: PythonImg,
    },
    {
      id: 5,
      im: NodeImg,
    },
    {
      id: 6,
      im: ReactImg,
    },
    {
      id: 7,
      im: XDImg,
    },
    {
      id: 8,
      im: FigmaImg,
    },
    {
      id: 9,
      im: OpenAiImg,
    },
    {
      id: 10,
      im: GeminiImg,
    },
    {
      id: 11,
      im: ClaudeImg,
    },
    {
      id: 12,
      im: CopilotImg,
    },
    {
      id: 13,
      im: TensorFlowImg,
    },
    {
      id: 14,
      im: PyTorchImg,
    },
    {
      id: 15,
      im: AwsImg,
    },
    {
      id: 16,
      im: LangChainImg,
    },
    {
      id: 17,
      im: lamaImg,
    },
    {
      id: 18,
      im: NvidiaImg,
    },
    {
      id: 19,
      im: StableDiffusionImg,
    },
    {
      id: 20,
      im: MidJourneyImg,
    },
  ];
  const techAltText = {
    1: "Artificial intelligence",
    2: "Google",
    3: "Angular",
    4: "Python",
    5: "Node.js",
    6: "React",
    7: "Adobe XD",
    8: "Figma",
    9: "OpenAI",
    10: "Google Gemini",
    11: "Claude AI",
    12: "Microsoft Copilot",
    13: "TensorFlow",
    14: "PyTorch",
    15: "Amazon Web Services",
    16: "LangChain",
    17: "LlamaIndex",
    18: "NVIDIA",
    19: "Stable Diffusion",
    20: "Midjourney",
  };
  let settingsSkills = {
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 8,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
        },
      },

      {
        breakpoint: 300,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  };
  function SamplePrevArow(props) {
    const { className, onClick } = props;
    return (
      <div
        className={className}
        style={{ background: "red", borderRadius: "50%", left: "-5px" }}
        onClick={onClick}
      />
    );
  }
  function SampleNextArow(props) {
    const { className, onClick } = props;
    return (
      <div
        className={className}
        style={{ background: "red", borderRadius: "50%", right: "0px" }}
        onClick={onClick}
      />
    );
  }

  let casestudySkills = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,

    arrows: true,
    nextArrow: <SampleNextArow />,
    prevArrow: <SamplePrevArow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },

      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const renderSlides = () =>
    arrayImg.map((curElem) => (
      <div key={curElem.id}>
        <img
          className="floating-icon"
          src={curElem.im}
          alt={techAltText[curElem.id] || "Technology logo"}
        />
      </div>
    ));
  const navigateToBlogListing = () => {
    navigate("/bloglisting");
  };
  const navigateToPortfolioListing = () => {
    navigate("/portfoliolisting");
  };

  const navigateToCaseStudy = (item) => {
    navigate(buildCaseStudyPath(item.id));
  };

  const caseStudyTabs = useMemo(() => {
    if (caseStudyItems.length > 0) {
      return caseStudyItems.map((item, index) => ({
        id: item.id || `case-${index + 1}`,
        title: item.title || "Case Study",
        details: {
          title: item.title || "Case Study",
          desc: item.subTitle || "",
          image: item.title || "",
        },
        apiId: item.id,
      }));
    }

    return (appData?.casestudy?.processData || []).map((item) => ({
      id: item.id,
      title: item.title || "Case Study",
      details: {
        title: item.details?.title || item.title || "Case Study",
        desc: item.details?.desc || "",
        image: item.details?.image || item.title || "",
      },
      apiId: null,
    }));
  }, [caseStudyItems, appData?.casestudy?.processData]);

  useEffect(() => {
    if (!caseStudyTabs.length) {
      setActiveCaseStudyTab(null);
      return;
    }

    setActiveCaseStudyTab((current) => {
      const hasCurrent = caseStudyTabs.some(
        (tab) => String(tab.id) === String(current),
      );

      return hasCurrent ? current : caseStudyTabs[0].id;
    });
  }, [caseStudyTabs]);

  useEffect(() => {
    if (!caseStudyTabs.length || !activeCaseStudyTab) {
      return;
    }

    const tabIds = caseStudyTabs.map((tab) => tab.id);
    const interval = setInterval(() => {
      setActiveCaseStudyTab((current) => {
        const currentIndex = tabIds.findIndex(
          (id) => String(id) === String(current),
        );
        const nextIndex =
          currentIndex === -1 || currentIndex === tabIds.length - 1
            ? 0
            : currentIndex + 1;

        return tabIds[nextIndex];
      });
    }, 4000);

    return () => clearInterval(interval);
  }, [caseStudyTabs, activeCaseStudyTab]);

  const shiftCaseStudyTab = (direction) => {
    if (!caseStudyTabs.length) {
      return;
    }

    const tabIds = caseStudyTabs.map((tab) => tab.id);
    const currentIndex = tabIds.findIndex(
      (id) => String(id) === String(activeCaseStudyTab),
    );
    const safeIndex = currentIndex === -1 ? 0 : currentIndex;
    const nextIndex =
      direction === "next"
        ? (safeIndex + 1) % tabIds.length
        : (safeIndex - 1 + tabIds.length) % tabIds.length;

    setActiveCaseStudyTab(tabIds[nextIndex]);
  };
  const CasestudyComponent = () => {
    if (!caseStudyTabs.length || !activeCaseStudyTab) {
      return (
        <div className="casestudy_Empty">
          <Label title="Case studies will appear here soon." />
        </div>
      );
    }

    return (
      <Tab.Container
        id="casestudy-tabs"
        activeKey={activeCaseStudyTab}
        onSelect={(selectedKey) => setActiveCaseStudyTab(selectedKey)}
        className="card_Section"
      >
        <Row className="card_Section">
          <Col sm={3} className="bottom_Section">
            <Nav variant="pills" className="tab_Section">
              <Nav.Item>
                {caseStudyTabs.map((curElem) => (
                  <Nav.Link
                    eventKey={curElem.id}
                    className="button"
                    key={curElem.id}
                    onClick={() => setActiveCaseStudyTab(curElem.id)}
                  >
                    {curElem.title}
                  </Nav.Link>
                ))}
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={9} className="content">
            <Tab.Content>
              {caseStudyTabs.map((curElem) => (
                <Tab.Pane eventKey={curElem.id} key={curElem.id}>
                  <div className="img_Content">
                    <div className="img_Section">
                      <img
                        src={getCaseStudyImage(curElem.details?.image)}
                        alt={curElem.title || "Case study"}
                      />
                    </div>
                  </div>
                  <div className="right_Section">
                    <div className="inner_Card">
                      <Label
                        title={curElem.details?.title || curElem.title || ""}
                        className="heading"
                      ></Label>
                      <Label title={curElem.details?.desc || ""}></Label>
                      <CustomButton
                        title="Know More"
                        onClick={() => {
                          if (curElem.apiId) {
                            navigateToCaseStudy({ id: curElem.apiId });
                          } else {
                            navigate(
                              `/casestudy/${encodeURIComponent(
                                String(curElem.title || "")
                                  .toLowerCase()
                                  .replace(/\s+/g, "-"),
                              )}`,
                            );
                          }
                        }}
                      ></CustomButton>
                    </div>
                  </div>
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    );
  };
  function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
      <div
        className={className}
        style={{ background: "red", borderRadius: "50%" }}
        onClick={onClick}
      />
    );
  }
  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <div
        className={className}
        style={{ background: "red", borderRadius: "50%" }}
        onClick={onClick}
      />
    );
  }
  let testimonialSkills = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },

      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return typeof appData.title === "string" ? (
    <div className="App">
      <Seo {...PAGE_SEO.home} />
      <Header />
      <div className="home_page">
        <div className="banner_Text">
          <div className="homepage-json-upload">
            <HomepageJsonUpload />
          </div>
          <Label title={t(appData.title)}></Label>
          <Label title={t(appData.subTitle)} className="bold"></Label>
          <Label title={t(appData.des)}></Label>
          <Label title={t(appData.subDesc)} className="small"></Label>
          <CustomButton
            title={t(appData.buttonTitle)}
            onClick={() => clickToNavigate("contactUs")}
          ></CustomButton>
          <div className="cursorP">
            <i className="icon-downs"></i>
          </div>
        </div>
        {/* Image slider */}
        <Slider {...settingsSkills} className="skill_Sectoion">
          {renderSlides()}
        </Slider>
        {/* about section */}
        <div className="about_Section">
          <div className="content_Section">
            <Label title={appData.about[0].title}></Label>
            <Label title={appData.about[0].desc}></Label>
          </div>
          <div className="card_Section">
            <div className="card_Items">
              <div className="card">
                <div className="content">
                  <i className="icon-dollar"></i>
                  <Label title={appData.services[0].title}></Label>
                  <Label title={appData.services[0].desc}></Label>
                </div>
              </div>
              <div className="card green">
                <div className="content">
                  <i className="icon-circle green"></i>
                  <Label
                    title={appData.services[1].title}
                    className="green"
                  ></Label>
                  <Label title={appData.services[1].desc}></Label>
                </div>
              </div>
            </div>
            <div className="card_Items">
              <div className="card orange">
                <div className="content">
                  <i className="icon-seo yellow"></i>
                  <Label
                    title={appData.services[2].title}
                    className="yellow"
                  ></Label>
                  <Label title={appData.services[2].desc}></Label>
                </div>
              </div>
              <div className="card blue">
                <div className="content">
                  <i className="icon-visible blue"></i>
                  <Label
                    title={appData.services[3].title}
                    className="blue"
                  ></Label>
                  <Label title={appData.services[3].desc}></Label>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* offering secion */}
        <div className="offerings_Section">
          <div className="content_Section">
            <Label title={appData.offerings[0].title}></Label>
            <Label
              className="sub-title"
              title={appData.offerings[0].desc}
            ></Label>
          </div>
          <div className="card_Section">
            <div className="card_Items marginT60">
              <div className="card marginB">
                <div className="content">
                  <img
                    src={UXImg}
                    className="sizes"
                    alt={appData.offerings[0].exploration[0].title}
                  />

                  <Label
                    title={appData.offerings[0].exploration[0].title}
                  ></Label>
                  <Label
                    title={appData.offerings[0].exploration[0].desc}
                  ></Label>
                </div>
              </div>
              <div className="card ">
                <div className="content">
                  <img
                    src={SeoImg}
                    className="sizes"
                    alt={appData.offerings[0].exploration[4].title}
                  />
                  <Label
                    title={appData.offerings[0].exploration[4].title}
                    className="blue"
                  ></Label>
                  <Label
                    title={appData.offerings[0].exploration[4].desc}
                  ></Label>
                </div>
              </div>
            </div>
            <div className="card_Items marginT140">
              <div className="card marginB">
                <div className="content">
                  <img
                    src={MobileImg}
                    className="sizes"
                    alt={appData.offerings[0].exploration[1].title}
                  />
                  <Label
                    title={appData.offerings[0].exploration[1].title}
                    className="yellow"
                  ></Label>
                  <Label
                    title={appData.offerings[0].exploration[1].desc}
                  ></Label>
                </div>
              </div>
              <div className="card ">
                <div className="content">
                  <img
                    src={SMMImg}
                    className="sizes"
                    alt={appData.offerings[0].exploration[3].title}
                  />
                  <Label
                    title={appData.offerings[0].exploration[3].title}
                    className="yellow"
                  ></Label>
                  <Label
                    title={appData.offerings[0].exploration[3].desc}
                  ></Label>
                </div>
              </div>
            </div>
            <div className="card_Items marginT100">
              <div className="card marginB">
                <div className="content">
                  <img
                    src={WebImg}
                    className="sizes"
                    alt={appData.offerings[0].exploration[2].title}
                  />
                  <Label
                    title={appData.offerings[0].exploration[2].title}
                    className=""
                  ></Label>
                  <Label
                    title={appData.offerings[0].exploration[2].desc}
                  ></Label>
                </div>
              </div>
              <div className="card ">
                <div className="content">
                  <img
                    src={IotImg}
                    className="sizes"
                    alt={appData.offerings[0].exploration[5].title}
                  />
                  <Label
                    title={appData.offerings[0].exploration[5].title}
                    className="blue"
                  ></Label>
                  <Label
                    title={appData.offerings[0].exploration[5].desc}
                  ></Label>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Work Section */}
        <div className="work_Section">
          <div className="content_Section">
            <div className="left_Content">
              <Label title={appData.workPortfolio.title}></Label>
              <Label title={appData.workPortfolio.desc}></Label>
            </div>
            <div
              className="more_Link cursorP"
              onClick={navigateToPortfolioListing}
            >
              <Label title="More"></Label>
              <i className="icon-more-right"></i>
            </div>
          </div>
          <div className="card_Section" style={{ cursor: "pointer" }}>
            <div className="card_Items">
              <div className="card">
                <div className="content" onClick={navigateToCaseStudy}>
                  <img
                    src={socialImg}
                    alt="Social media app portfolio project"
                  />
                </div>
              </div>
              <div className="card">
                <div className="content" onClick={navigateToCaseStudy}>
                  <img
                    src={scooterImg}
                    alt="Scooter rental app portfolio project"
                  />
                </div>
              </div>
            </div>
            <div className="card_Items">
              <div className="card">
                <div className="content" onClick={navigateToCaseStudy}>
                  <img src={healthImg} alt="Healthcare app portfolio project" />
                </div>
              </div>
              <div className="card">
                <div className="content" onClick={navigateToCaseStudy}>
                  <img
                    src={storeImg}
                    alt="Retail store app portfolio project"
                  />
                </div>
              </div>
            </div>
            <div className="card_Items">
              <div className="card">
                <div className="content" onClick={navigateToCaseStudy}>
                  <img
                    src={tradeImg}
                    alt="Trading platform portfolio project"
                  />
                </div>
              </div>
              <div className="card">
                <div className="content" onClick={navigateToCaseStudy}>
                  <img
                    src={shoppingImg}
                    alt="E-commerce app portfolio project"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* //process_Section */}
        <div className="process_Section">
          <div className="content_Section">
            <Label title={appData.processmanagement.title}></Label>
            <Label title={appData.processmanagement.desc}></Label>
          </div>

          <Tab.Container
            id="left-tabs-example"
            // defaultActiveKey={1}
            activeKey={key}
          >
            <Row className="card_Section">
              <Col sm={2} className="left_Section">
                <Nav variant="pills" className="tab_Section">
                  <Nav.Item>
                    {appData.processmanagement.processData.map(
                      (curElem, index) => {
                        return (
                          <Nav.Link eventKey={curElem.id}>
                            {curElem.title}
                          </Nav.Link>
                        );
                      },
                    )}
                  </Nav.Item>
                </Nav>
              </Col>
              <Col className="right_Section">
                <Tab.Content>
                  {appData.processmanagement.processData.map(
                    (curElem, index) => {
                      return (
                        <Tab.Pane eventKey={curElem.id} key={curElem.id}>
                          <div className="inner_Card">
                            <img
                              src={productImg}
                              alt={
                                curElem?.details[0]?.title ||
                                "Process illustration"
                              }
                            />

                            <Label
                              title={curElem?.details[0]?.title}
                              className="heading"
                            ></Label>
                            <Label title={curElem?.details[0]?.desc}></Label>

                            {/* <Label title={curElem?.detsils[0]?.title}></Label> */}
                          </div>
                          <div className="inner_Card">
                            <img
                              src={workshopImg}
                              alt={
                                curElem?.details[1]?.title ||
                                "Workshop illustration"
                              }
                            />

                            <Label
                              title={curElem?.details[1]?.title}
                              className="heading"
                            ></Label>
                            <Label title={curElem?.details[1]?.desc}></Label>
                          </div>
                        </Tab.Pane>
                      );
                    },
                  )}
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
        {/* Why section */}
        <div className="why_Section">
          <div className="content_Section">
            <Label title={appData?.why?.title}></Label>
            <Label title={appData?.why?.desc}></Label>
          </div>
          <div className="card_Section">
            <div className="left_Section">
              <Label
                title={appData?.why?.data[0]?.heading}
                className="heading"
              ></Label>

              <Label title={appData?.why?.data[0]?.desc}></Label>

              <div className="tab_Section">
                {appData?.why?.data[0]?.points.map((item, index) => (
                  <CustomButton
                    key={index}
                    title={item.title}
                    className={
                      activeIndex === index ? "button active" : "button"
                    }
                    onClick={() => setActiveIndex(index)}
                  />
                ))}
              </div>
            </div>
            <div className="right_Section">
              <Label
                title={appData?.why?.data[0]?.points[activeIndex]?.title}
                className="heading"
              ></Label>
              <Label
                title={appData?.why?.data[0]?.points[activeIndex]?.desc}
              ></Label>
            </div>
          </div>
        </div>
        {/* <div className="why_Section">
          <div className="content_Section">
            <Label title={appData?.why?.title}></Label>
            <Label title={appData?.why?.desc}></Label>
          </div>
          <div className="card_Section">
            <div className="left_Section">
              <Label
                title={appData?.why?.data[0]?.heading}
                className="heading"
              ></Label>
              <Label title={appData?.why?.data[0]?.desc}></Label>
              <div className="tab_Section">
                <CustomButton
                  title={appData?.why?.data[0]?.points[0]?.desc}
                  className="button active"
                ></CustomButton>
                <CustomButton
                  title={appData?.why?.data[0]?.points[1]?.desc}
                  className="button"
                ></CustomButton>
                <CustomButton
                  title={appData?.why?.data[0]?.points[2]?.desc}
                  className="button"
                ></CustomButton>
                <CustomButton
                  title={appData?.why?.data[0]?.points[3]?.desc}
                  className="button"
                ></CustomButton>
              </div>
            </div>
            <div className="right_Section">
              <Label
                title={appData?.why?.carousalCards?.title}
                className="heading"
              ></Label>
              <Label
                title={appData?.why?.carousalCards?.points[0]?.desc}
              ></Label>
              <Label
                title={appData?.why?.carousalCards?.points[1]?.desc}
              ></Label>
            </div>
          </div>
        </div>*/}
        {/* casestudy section  */}
        <div className="casestudy_Section">
          <div className="content_Section">
            <Label title={appData.casestudy.title}></Label>
            <Label title={appData.casestudy.desc}></Label>
          </div>
          <div className="casestudy_Wrapper">
            <button
              type="button"
              className="casestudy-arrow casestudy-arrow-prev"
              aria-label="Previous case study"
              onClick={() => shiftCaseStudyTab("prev")}
            />
            <CasestudyComponent />
            <button
              type="button"
              className="casestudy-arrow casestudy-arrow-next"
              aria-label="Next case study"
              onClick={() => shiftCaseStudyTab("next")}
            />
          </div>
        </div>
        <div className="blog_Section">
          <div className="content_Section">
            <div className="left_Content">
              <Label title={appData.blog.title}></Label>
              <Label title={appData.blog.desc}></Label>
            </div>
            <div className="more_Link cursorP" onClick={navigateToBlogListing}>
              <Label title="More"></Label>
              <i className="icon-more-right"></i>
            </div>
          </div>
          <div className="card_Section">
            {randomItems.map((item) => (
              <div
                className="card_Items"
                key={item.id}
                onClick={() => navigateToBlogPage(item)}
                style={{ cursor: "pointer" }}
              >
                <div className="card">
                  <div className="img">
                    <img
                      src={getBlogImage(item, AutomationImg)}
                      alt={item.title}
                      onError={(e) => {
                        e.currentTarget.style.display = "none";
                        e.currentTarget.parentElement.classList.add(
                          "image-error",
                        );
                      }}
                    />
                  </div>
                  <div className="content">
                    <Label title={item.topic} className="pholder"></Label>
                    <Label title={item.title} className="heading"></Label>
                    <Label title={item.desc} className="label"></Label>
                    <span className="colorRed">READ MORE</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* testimonial section */}
        <div className="testimonials_Section">
          <div className="content_Section">
            <Label title={appData.testimonials.title}></Label>
            <Label title={appData.testimonials.desc}></Label>
          </div>

          <div className="card_SectionTest">
            <Slider {...testimonialSkills} className="testimonials_Sectoion">
              {appData &&
                appData.testimonials.data.map((element, index) => {
                  return (
                    <div className="testimonals" key={index}>
                      <div className="inner_Testimonals">
                        <img
                          src={quoteTopImg}
                          className="paddB"
                          alt="Opening quotation mark"
                        />
                        <Label title={element.detailsTestimony}></Label>
                        <img
                          src={quoteBottomImg}
                          className="paddT"
                          alt="Closing quotation mark"
                        />
                      </div>
                      <Label title={element.name} className="from_Name"></Label>
                      <Label
                        title={element.designation}
                        className="post"
                      ></Label>
                    </div>
                  );
                })}
            </Slider>
          </div>
        </div>
        <ContactUs />
        <Footer />
      </div>
    </div>
  ) : (
    <div className="loader-div">
      <div className="loader">
        <lottie-player
          autoplay
          loop
          src="https://lottie.host/7d0ba31f-e11f-47ed-8248-b1a8f5389ad8/oMZAHSKOuQ.json"
        ></lottie-player>
      </div>
    </div>
  );
};

export default Homepage;
